import type { CardProps } from "@nextui-org/react";

import React from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Button,
  Spacer,
  Link,
  Chip,
} from "@nextui-org/react";

interface CardWithThumbnailProps
  extends Omit<CardProps, keyof React.ComponentProps<typeof Card>> {
  title: string;
  description: string;
  imageLink: string;
  githubUrl?: string;
  websiteUrl: string;
  stackLabels: string[];
}

export default function CardWithThumbnail({
  title,
  description,
  imageLink,
  githubUrl,
  websiteUrl,
  stackLabels,
  ...props
}: CardWithThumbnailProps) {
  return (
    <Card className="w-[320px] sm:w-[420px]" {...props}>
      <CardBody className="px-3 pb-1">
        <video
          className="aspect-video w-full rounded-xs object-cover object-top"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={imageLink} type="video/mp4" />
        </video>
        <Spacer y={2} />
        <div className="flex flex-col gap-2 px-2">
          <p className="text-large font-medium">{title}</p>
          <p className="text-small text-default-400">{description}</p>
        </div>
      </CardBody>
      <CardFooter className="flex flex-col gap-2 px-2">
        <div className="flex flex-wrap gap-2 px-2">
          {stackLabels.map((label, index) => (
            <Chip key={index} color="default" variant="bordered" size="sm">
              {label}
            </Chip>
          ))}
        </div>
        <div className="flex w-full justify-end gap-2">
          <Button
            fullWidth
            href={githubUrl}
            as={Link}
            isExternal
            showAnchorIcon
            color="default"
            variant="bordered"
            disabled={true}  // TODO: DISABLED DOES NOT WORK
          >
            Github
          </Button>
          <Button
            fullWidth
            href={websiteUrl}
            as={Link}
            isExternal
            showAnchorIcon
            color="secondary"
          >
            Visit
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
}
